export const rolesRoutes = [
    {
      role: "IT",
      allowedRoutes: ["*"]
    },
    {
      role: "Coordinador",
      allowedRoutes: [
        "/", //home
        "/modules",
        "/modules/catalogs",
        "/modules/reports",
        "/modules/catalogs/internal-orders",
        "/modules/catalogs/activities",
        "/modules/catalogs/zones",
        "/modules/reports/consolidado-forestal",
      ]
    },
    {
      role: "RRHH",
      allowedRoutes: [
        "/", //home
        "/modules",
        "/modules/catalogs",
        "/modules/reports",
        "/modules/catalogs/employees",
        '/modules/catalogs/groups',
        '/modules/catalogs/absence-reasons',
        '/modules/catalogs/cost-centers',
        '/modules/reports/labores-empleados'
      ]
    },
    {
      role: "Aprobador",
      allowedRoutes: [
        "/", //home
        "/modules",
        "/modules/records",
        "/modules/reports",
        '/modules/records/activity-log',
        '/modules/records/activity-log/*',
        '/modules/records/attendance-log',
        '/modules/records/attendance-log/*',
        '/modules/records/approvals',
        "/modules/reports/consolidado-forestal",
      ]
    },
    {
      role: "Mayordomo",
      allowedRoutes: [
        "/", //home
        "/modules",
        "/modules/records",
        '/modules/records/activity-log',
        '/modules/records/activity-log/*',
        '/modules/records/attendance-log',
        '/modules/records/attendance-log/*',
      ]
    },
    {  allRoutesForReferenceOnly: [
        "/", //home
        "/modules",
        "/modules/records",
        "/modules/reports",
        "/modules/catalogs",
        '/modules/records/activity-log',
        '/modules/records/activity-log/*',
        '/modules/records/attendance-log',
        '/modules/records/attendance-log/*',
        '/modules/records/approvals',
        '/modules/reports/labores-empleados',
        "/modules/reports/consolidado-forestal",
        "/modules/catalogs/internal-orders",
        "/modules/catalogs/zones",
        "/modules/catalogs/activities",
        "/modules/catalogs/approvers",
        "/modules/catalogs/processes",
        "/modules/catalogs/subprocesses",
        "/modules/catalogs/employees",
        "/modules/catalogs/groups",
        "/modules/catalogs/absence-reasons",
        '/modules/catalogs/cost-centers',
        "/modules/catalogs/users",
        "/modules/catalogs/roles"
      ]
    }
  ]